console.log("Tabletop Goodies - Script - HTML");

TTG = function (parent) {
    const result = {};

    const _parseName = (name, start, end) => {
        const a1 = name.indexOf(start);
        const a2 = name.indexOf(end);
        if (a1 > 0 && a2 > a1 + 1)
        {
            const r = {};
            r.n = name.substring(0, a1);
            r.i = Number(name.substring(a1 + 1, a2));
            return r;
        }
        else
        {
            return null;
        }
    }
 

    const _setObjectValue = (o, p, v) =>
    {
        const ps = p.split('.');
        var c = o;
        for (var j = 0; j < ps.length; j++) {
            const n = ps[j];
            const a = _parseName(n, '[', ']');
            if (j === ps.length - 1) {
                
                if (a || c.hasOwnProperty(n)) { // The final value in an array
                    var ar;
                    if (c.hasOwnProperty(n)) {
                        ar = c[n];
                        if (!Array.isArray(ar)) {
                            c[n] = [];
                            c[n].push(ar);
                            ar = c[n];
                        }
                    }
                    if (a && a.i) {
                        ar[a.i] = v;
                    }
                    else {
                        ar.push(v);
                    }
                }
                else { 
                    c[n] = v;
                }
            }
            else
            {
                if (a) {
                    if (typeof a.i === 'undefined' || a.i == null) {
                        throw "Invalid path: '" + p + "'. '" + n + "' needs to have an index value.";
                    }
                    else
                    {
                        var s = c[a.n];
                        if (typeof s === 'undefined' || s == null) {
                            c[a.n] = [];
                            c[a.n][a.i] = {};
                            c = c[a.n][a.i];
                        }
                        else
                        {
                            if (Array.isArray(s))
                            {
                                if (s.length > a.i)
                                {
                                    s = s[a.i];
                                    if (BGE.isObject(s)) {
                                        c = s;
                                    }
                                    else {
                                        throw "Invalid path: '" + p + "Array value at index #" + a.i + " is not an object. (" + n + ")";
                                    }
                                }
                                else {
                                    s[a.i] = {};
                                    c = s[a.i];
                                }
                            }
                            else {
                                throw "Invalid path: '" + p + "'. '" + n + "' is not an array.";
                            }
                        }
                    }
                }
                else {
                    var s = c[n];
                    if (typeof s === 'undefined' || s == null) {
                        c[n] = {};
                        c = c[n];
                    }
                    else {
                        if (TTG.isObject(s)) {
                            c = s;
                        }
                        else {
                            throw "Invalid path: '" + p + "'. '" + n + "' is not an object.";
                        }
                    }
                }
            }
        }
    }

    const _getFormAsObject = (target, ignoreValues) =>
    {
        const r = {};
        const inputs = $('input, select, textarea, [data-field-name!=""]', target);
        for (var i = 0; i < inputs.length; i++) {
            const input = inputs.get(i);
            var name = input.getAttribute("data-field-name");
            if (TTG.isNullOrWhiteSpaces(name)) {
                name = input.name;
            }
            if (!TTG.isNullOrWhiteSpaces(name) && (!ignoreValues || !ignoreValues.includes(name)))
            {
                var v = null;
                switch (input.type) {
                    case 'checkbox':
                    case 'radio':
                        v = input.checked;
                        break;
                    default:
                        v = input.value;
                        break;
                }
                _setObjectValue(r, name, v);
            }
        }
        return r;
    }

  
    const _alreadyLoadedCSSs = new Set();
    
    const _loadCSS = (cssUrl) => 
      {
        if(!_alreadyLoadedCSSs.has(cssUrl.toLowerCase()))
        {
           console.log("Tabletop Goodies - Stylesheet - " + cssUrl)
          _alreadyLoadedCSSs.add(cssUrl.toLowerCase());

          const link = document.createElement("link");
          link.rel = "stylesheet";
          link.href = cssUrl;
          link.type = "text/css";
          link.media = "all";
          document.head.appendChild(link); 
        }
      }
  
    const _encodeHtml = function (htmlString) {
        const tempDiv = document.createElement("div");
        tempDiv.textContent = htmlString;
        return tempDiv.innerHTML;
    }

  result.loadCSS = _loadCSS;
    result.encodeHtml = _encodeHtml;
    result.getFormAsObject = _getFormAsObject;

    parent.Html = result;
    return parent;
}(TTG);